import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'

const renderIcon = (color: string) => (
    <path d='M3 12L8 17M3 12L8 7M3 12H21' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
)

export const ArrowPointerLeft: React.FC<IconProps> = ({ color, size }) => (
    <IconWrapper {...{ size, color }} renderIcon={renderIcon} />
)
